import { usePWAInstall } from '@/hooks/usePWAInstall'
import { Download, X, Share } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function PWAInstallBanner() {
  const { canPrompt, showIOSGuide, install, dismiss } = usePWAInstall()

  if (!canPrompt && !showIOSGuide) return null

  return (
    <div className="mx-4 mt-3 bg-emerald-50 border border-emerald-200 rounded-xl p-3.5 flex items-start gap-3 relative">
      <div className="shrink-0 w-9 h-9 rounded-lg bg-emerald-600 flex items-center justify-center">
        <Download className="h-4 w-4 text-white" />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900">Install App</p>
        {showIOSGuide ? (
          <p className="text-xs text-gray-600 mt-0.5 leading-relaxed">
            Tap <Share className="inline h-3 w-3 text-blue-500 -mt-0.5" /> then <span className="font-medium">"Add to Home Screen"</span> for the best experience.
          </p>
        ) : (
          <>
            <p className="text-xs text-gray-600 mt-0.5">Add to your home screen for quick access and offline support.</p>
            <Button
              size="sm"
              className="mt-2 h-7 text-xs bg-emerald-600 hover:bg-emerald-700 px-4"
              onClick={install}
            >
              Install
            </Button>
          </>
        )}
      </div>

      <button
        onClick={dismiss}
        className="shrink-0 p-1 hover:bg-emerald-100 rounded-lg transition-colors -mr-1 -mt-1"
      >
        <X className="h-3.5 w-3.5 text-emerald-700" />
      </button>
    </div>
  )
}
